/**
 * Programmatically starts a file download from a blob/object URL (no full-page navigation).
 *
 * @param {string} objectUrl - From `URL.createObjectURL(blob)`
 * @param {string} fileName - Suggested download filename
 */
export function triggerDownloadFromObjectUrl(objectUrl, fileName) {
  const anchor = document.createElement("a");
  anchor.href = objectUrl;
  anchor.download = fileName;
  anchor.rel = "noopener noreferrer";
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
}

/**
 * Saves binary API data as a downloaded file. Builds an object URL, triggers download, then revokes the URL.
 *
 * @param {Blob | ArrayBuffer | ArrayBufferView | BlobPart[]} data
 * @param {string} fileName
 */
export function downloadBlobAsFile(data, fileName) {
  if (data == null) return;

  const blob = data instanceof Blob ? data : new Blob([data]);
  const objectUrl = URL.createObjectURL(blob);

  try {
    triggerDownloadFromObjectUrl(objectUrl, fileName);
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
}
